$(document).ready(function () {
   jQuery('main').insertAfter('header');
  countDownIni('.flip-countdown,.js-flip-countdown');
     // Browser vise class add to the body js start
 /**
 * Detect OS & browsers
 */
 /* Add class for mac */
 if (navigator.appVersion.indexOf("Win") != -1) {
  jQuery('body').addClass('window-os');
}
if (navigator.platform.toUpperCase().indexOf('MAC') >= 0) {
  jQuery('body').addClass('mac-os');
}
if (navigator.appVersion.indexOf("Linux") != -1) {
  jQuery('body').addClass('linux-os');
}
/* Add class for all ie version */
var trident = !!navigator.userAgent.match(/Trident\/7.0/);
var net = !!navigator.userAgent.match(/.NET4.0E/);
var IE11 = trident && net;
var IEold = (navigator.userAgent.match(/MSIE/i) ? true : false);
if (IE11 || IEold) {
  jQuery('body').addClass('ie');
}
var ua = navigator.userAgent.toLowerCase();
if (ua.indexOf('safari') != -1) {
  if (ua.indexOf('chrome') > -1) {
      jQuery('body').addClass('isChrome');
  } else {
      jQuery('body').addClass('isSafari');
  }
}
var FF = !(window.mozInnerScreenX == null);
if (FF) {
  jQuery('body').addClass('fire-fox');
} else {
  //jQuery('body').addClass('not-fire-fox');
}

    // /********* On scroll heder Sticky *********/
    function initHeaderSticky() {
        if (jQuery(document).height() > jQuery(window).height()) {
            if (jQuery(this).scrollTop() > 250) {
              jQuery('.site-header').addClass("fixed");
            } else {
              jQuery('.site-header').removeClass("fixed");
            }
          } 
        }
  
      $(document).ready(function () {
        initHeaderSticky()
      });
      $(window).on('resize scroll', function () {
        initHeaderSticky()
      });

    // /********* On scroll heder back *********/

    var prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("header-sticky").style.transform = "none";
        } else {
          if (jQuery(this).scrollTop() > 250) {
            document.getElementById("header-sticky").style.transform = "translateY(-100%)";
          }
        }
        prevScrollpos = currentScrollPos;
    }
      /********* Mobile Menu ********/

      /******  menu hover  ******/
     // Open the mobile menu
    $('body').on('click', '.mobile-menu-button', function (e) {
      e.preventDefault();
      setTimeout(function () {
          $('body').addClass('no_scroll active_menu');
          $('.overlay').addClass('active');
      }, 50);
  });
  
  // Open the mainmenu desk & mob
$(window).on("resize", function() {
  if ($(window).width() < 992) {
      $('body').off('mouseenter mouseleave', '.main-menu.has-item'); // Unbind hover events
      $('body').on('click', '.main-menu.has-item > a', function(e) {
          e.preventDefault();
          var $parentMenu = $(this).closest('.main-menu.has-item');
          $parentMenu.addClass("menu_active");
          $parentMenu.find(".menu-dropdown").addClass("open_menu");
      });
  } else {
      $('body').off('click', '.main-menu.has-item > a'); // Unbind click events
      $('body').on('mouseenter', '.main-menu.has-item', function(e) {
          e.preventDefault();
          var $parentMenu = $(this).closest('.main-menu.has-item');
          $parentMenu.addClass("menu_active");
          $parentMenu.find(".menu-dropdown").addClass("open_menu");
          $("body").addClass("no_scroll");
      }).on('mouseleave', '.main-menu.has-item', function(e) {
          e.preventDefault();
          $(this).removeClass("menu_active");
          $(this).find(".menu-dropdown").removeClass("open_menu");
          $("body").removeClass("no_scroll");
      });
  }
}).resize();
   // Close the main-menu
  $('body').on('click', '.back-menu-button', function () {
      $('.main-menu.has-item').removeClass("menu_active");
      $('.menu-dropdown').removeClass("open_menu");
  });

   // Open the submenu
  $('body').on('click', '.sub-menu-lnk > a', function (e) {
      e.preventDefault();
      var $parentMenu = $(this).closest('.sub-menu-lnk');
      $parentMenu.addClass("menu_active");
      $parentMenu.find(".sub-menu-dropdown").addClass("open_menu");
  });

 // Close the submenu
  $('body').on('click', '.sub-menu-back', function () {
      $('.sub-menu-lnk').removeClass("menu_active");
      $('.sub-menu-dropdown').removeClass("open_menu");
  });
  
  // Close all menu
  $('body').on('click', '.overlay, .menu-close-icon svg', function (e) {
      e.preventDefault();
      $('.main-menu.has-item').removeClass("menu_active");
      $('.overlay').removeClass('active');
      $('body').removeClass('no_scroll active_menu');
      $(".menu-dropdown").removeClass("open_menu");
      $('.sub-menu-lnk').removeClass("menu_active");
      $('.sub-menu-dropdown').removeClass("open_menu");
  });
      /********* mobile stickybar ********/
      $(window).scroll(function () {
        if ($(window).scrollTop() > 100) {
          $(".mobile-stickybar").addClass('show');
        } else {
          $(".mobile-stickybar").removeClass('show');
        }
      });

      /*********  Multi-level accordion nav (header & faq) ********/
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
          list.slideUp('fast');
          parent.removeClass('is-open');
        }
        else {
          list.slideDown('fast');
          parent.addClass('is-open');
        }
      });
      $('.faqs-acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.faqs-has-children');
        var list = label.siblings('.faqs-acnav-list');
  
        // Close all other open sections
        $('.faqs-has-children').not(parent).removeClass('is-open');
        $('.faqs-acnav-list').not(list).slideUp('fast');
  
        // Toggle the clicked section
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        } else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });
   // currency-nice-select
    $('body').on('click', '.country-name .nice-select', function (e) {
      e.stopPropagation(); // Stop the event from propagating to the body
      $(this).toggleClass('open');
    });
    $('body').on('click', function (e) {
      $('.country-name .nice-select').removeClass('open');
    });
  // currency
    function currencyFormSubmit(event) {
      event.target.form.submit();
    }
    document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
      currencyItem.addEventListener('click', function () {
        // Trigger change event on the associated select element
        var selectElement = this.closest('.country-name').querySelector('select');
        if (selectElement) {
          // Set the selected option based on the data-currency attribute of the clicked li
          selectElement.value = this.dataset.currency;
          
          // Trigger change event
          var event = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(event);
    
          // Submit the form
          currencyFormSubmit({ target: selectElement });
        }
      });
    });
    /********* Cart Popup ********/
        if ($('body').hasClass('cart')) {
        // Disable click on the cart-header div
        $('.cart-header').on('click', function(event) {
            event.preventDefault();
            return false;
        });
    }else{

    $('.cart-header').on('click', function (e) {
    e.preventDefault();
      $('body').addClass('no_scroll cartopen');
      $('.overlay').addClass('active');
  });
    
  }

  $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
    e.preventDefault();
    $('.overlay').removeClass('active');
    $('body').removeClass('no_scroll cartopen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

    /*********coupon popup ********/
      $(document).on('click', '.coupon-icon', function () {
        $(".coupon-popup").toggleClass("active");
      });
      $(document).on('click', '.gift-icon', function () {
        $(".coupon-popup").removeClass("active");
      });
      $(document).on('click', '.close-coupon', function () {
        $(".coupon-popup").removeClass("active");
      });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply-coupon-btn').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply-coupon-btn').attr("href",apply_href+'discount='+val);
       $('.apply-coupon-btn').trigger('click');
    });
  
/*********gift popup ********/
    $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").addClass("active");
  });
  $(document).on('click', '.coupon-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });

  // product slider zoom
    $('.product-item-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
  
      /******* quick-view-popup Js *******/

  $(".quick-close-btn").click(function () {
    $(".quick-view-popup").removeClass("active");
    $("body").removeClass("no_scroll");
  });
  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    var href= '/products/'+$(this).data('handle')+'?view=qv';

    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
    var swiper = new Swiper(".quickview-image-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 800,
        navigation: {
            nextEl: ".quickview-btn-next.swiper-button-next",
            prevEl: ".quickview-btn-prev.swiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            }
        },
    });    
    });
    $(".quick-view-popup").toggleClass("active");
    $("body").toggleClass("no_scroll");
  });

  $('body').on('click', '.quickview_popup_data .radio-buttons .button', function() {
   var data_val = $(this).children('input:checked').val();
   $(this).parents('.color-variant-swatch').find('.option-label').text(data_val);
  
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .radio-buttons .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    variant_title = String(variant_title);
    
    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      
      var variantImageIndex = $('.quickview-image-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-image-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add To Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
  
  // custom reviews on product page
  $(window).on('load', function() {
    $(".pdp-right-column").find(".jdgm-prev-badge").append("<a class='product-write-review flex align-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#fff' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  }); 
     setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab-sec').find("li.active").removeClass('active');
    $('.pdp-tab-sec').find("li[data-tab='pdp-tab-3']").addClass('active');
    $('.tab-content.active').removeClass('active');
    $(".tab-content[id='pdp-tab-3']").addClass('active'); 
    });
  }, 1000); 

   setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab').find('.review_tab').addClass('is-open');
    $('.review_tab.is-open').find('.acnav-list').css('display','block');  
    });
  }, 1000); 

   // notify me
            $('body').on('click','.notify-btn', function(e) {
                e.preventDefault();
                $('body').addClass('no_scroll notify-active');
                $('.out-of-stock-form,.overlay').addClass('active');
              });
             $('body').on('click','.overlay,.notify-popup-close', function(e) {
                e.preventDefault();
               $('body').removeClass('no_scroll notify-active');
                $('.out-of-stock-form,.overlay').removeClass('active');
              });
   var swiper = new Swiper(".related-sidebar-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      475: {
        slidesPerView: 1,
      },
    },
  });
 // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show_btn');
        } else {
          $('.products-add-cart-sticky').addClass('show_btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.pdp-page-main-sec').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky

      /**************************/
       //  Header Search Popup  // 
      /**************************/
  
      $(".search-header a").click(function () {
        $(".search-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
        $('.overlay').addClass('active');
        $('body').addClass('search-overlay');
      });
      $(".close-search ,.overlay").click(function () {
        $(".search-popup").removeClass("active");
        $("body").removeClass("no_scroll"); +
        $('.overlay').removeClass('active');
        $('body').removeClass('search-overlay');
      });

   /**************************/
        // footer acnav // 
  /**************************/

  $(".footer-acnav").on("click", function () {
    if ($(window).width() < 768) {
      if ($(this).hasClass("is-open")) {
          $(this).removeClass("is-open");
          $(this).siblings(".footer-acnav-list").slideUp(200);
      } else {
          $(".footer-acnav").removeClass("is-open");
          $(this).addClass("is-open");
          $(".footer-acnav-list").slideUp(200);
          $(this).siblings(".footer-acnav-list").slideDown(200);
      }
    }
  });

  /****  TAB Js ****/
   $("ul.tabs li").click(function () {
    var $this = $(this);
    var $theTab = $(this).attr("data-tab");
    if ($this.hasClass("active")) {
    } else {
        $this
            .closest(".tabs-wrapper")
            .find("ul.tabs li, .tabs-container .tab-content")
            .removeClass("active");
        $(
            '.tabs-container .tab-content[id="' +
            $theTab +
            '"], ul.tabs li[data-tab="' +
            $theTab +
            "]"
        ).addClass("active");
    }
    $(this).addClass("active");
});
    /**************************/
    // Subscribe popup Js // 
    /**************************/
    if ($('.subscribe-popup').length > 0) {
      $('.subscribe-popup').addClass('active');
      $('body').addClass('no-scroll');
      $(".overlay").addClass("active");
  };
  $('body').on('click', '.overlay , .close-sub-btn', function (e) {
      e.preventDefault();
      $("body").removeClass("no-scroll");
      $(".overlay").removeClass("active");
      $(".subscribe-popup").removeClass("active");
  });
  
    /******* Cookie Js *******/
    $('.cookie-btn').click(function () {
      $('.cookie-popup').removeClass("active");
  });

   /******* notification-popup Js *******/
   $('.notification-close-btn ').click(function () {
    $('.product-notification-popup').removeClass("active");
});

  
 // progress-wrap

 $(document).ready(function(){"use strict";
      
  var progressPath = document.querySelector('.progress-wrap path');
  var pathLength = progressPath.getTotalLength();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect();
  progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
  var updateProgress = function () {
    var scroll = $(window).scrollTop();
    var height = $(document).height() - $(window).height();
    var progress = pathLength - (scroll * pathLength / height);
    progressPath.style.strokeDashoffset = progress;
  }
  updateProgress();
  $(window).scroll(updateProgress);	
  var offset = 50;
  var duration = 550;
  jQuery(window).on('scroll', function() {
    if (jQuery(this).scrollTop() > offset) {
      jQuery('.progress-wrap').addClass('active-progress');
    } else {
      jQuery('.progress-wrap').removeClass('active-progress');
    }
  });				
  jQuery('.progress-wrap').on('click', function(event) {
    event.preventDefault();
    jQuery('html, body').animate({scrollTop: 0}, duration);
    return false;
  });
});
  
/** product-card-slider **/
var swiper = new Swiper(".product-card-slider", {
  slidesPerView: 4.1,
  spaceBetween: 15,
  loop: true,
  centeredSlides: true,
  speed: 800,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
},
  breakpoints: {
    1200: {
      slidesPerView: 4.1,
    },
    768: {
      slidesPerView: 3.1,
    },
    576: {
      slidesPerView: 2.1,
    },
    0: {
      slidesPerView: 1,
    },
  },
});

/** partner logo slider **/
var swiper = new Swiper(".partner-logo-slider", {
  spaceBetween: 20,
  slidesPerView: 6,
  loop: true,
  autoplay:true,
  navigation: {
    nextEl: '.partner-btn-next.swiper-button-next',
    prevEl: '.partner-btn-prev.swiper-button-prev',
  },
  breakpoints: {
    1200: {
      slidesPerView: 6,
    },
    992: {
      slidesPerView: 4,
    },
    768: {
      slidesPerView: 3,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    0: {
      slidesPerView: 1,
    }
  },
});

/** product-category-slider **/
var swiper = new Swiper(".product-category-slider", {
  slidesPerView: 3,
  spaceBetween: 15,
  loop: true,
  speed: 800,
  navigation: {
    nextEl: '.category-btn-next.swiper-button-next',
    prevEl: '.category-btn-prev.swiper-button-prev',
  },
  breakpoints: {
    1200: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    },
    576: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  },
});

/** home-blog-slider **/
var swiper = new Swiper(".home-blog-slider", {
  slidesPerView: 4,
  spaceBetween: 15,
  loop: true,
  speed: 800,
  navigation: {
    nextEl: '.blog-btn-next.swiper-button-next',
    prevEl: '.blog-btn-prev.swiper-button-prev',
  },
  breakpoints: {
    1200: {
      slidesPerView: 4,
    },
    992: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 3,
    },
    576: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  },
});
/** bestseller-product-slider **/
var swiper = new Swiper(".bestseller-product-slider", {
  slidesPerView: 4,
  spaceBetween: 15,
  loop: true,
  speed: 800,
  navigation: {
    nextEl: '.bestseller-btn-next.swiper-button-next',
    prevEl: '.bestseller-btn-prev.swiper-button-prev',
  },
  breakpoints: {
    1200: {
      slidesPerView: 4,
    },
    992: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 3,
    },
    576: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1,
    },
  },
});
/** testimonial-slider **/
var swiper = new Swiper(".testimonial-slider", {
  slidesPerView: 2,
  spaceBetween: 15,
  loop: true,
  speed: 800,
  navigation: {
    nextEl: '.testimonial-btn-next.swiper-button-next',
    prevEl: '.testimonial-btn-prev.swiper-button-prev',
  },
  breakpoints: {
  
    768: {
      slidesPerView: 2,
    },
    576: {
      slidesPerView: 1,
    },
    0: {
      slidesPerView: 1,
    },
  },
});
   // left slider
   var leftsliderThumbnail = new Swiper(".pro-thumb-slider", {
    centeredSlides: false,
    centeredSlidesBounds: true,
    slidesPerView: 4,
    spaceBetween: 20,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: "horizontal",  
    breakpoints: {
      992: {
        slidesPerView: 4,
        direction: 'vertical', 
      },
      768: {
        direction: 'horizontal', 
        slidesPerView: 3,
        spaceBetween: 15,
      },
      576: {
        direction: 'horizontal', 
        slidesPerView: 4,
      },
      320: {
        direction: 'horizontal', 
        slidesPerView: 3,
      },
    },
  });

  var leftsliderMain = new Swiper(".pro-main-slider", {
     loop: false,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.pdp-thumb-arrow.swiper-button-next',
      prevEl: '.pdp-thumb-arrow.swiper-button-prev',
    },
    thumbs: {
      swiper: leftsliderThumbnail
    }
  });
   
  leftsliderMain.on('slideChangeTransitionStart', function() {
    leftsliderThumbnail.slideTo(leftsliderMain.activeIndex);
  });

  leftsliderThumbnail.on('transitionStart', function(){
    leftsliderMain.slideTo(leftsliderThumbnail.activeIndex);
  });

      /*********  ask qustion Popup  ********/
      $(".pro-features li a.ask-qus").click(function () {
        $(".ask-qus-popup").addClass("active");
        $("body").addClass("no_scroll");
        $('.overlay').addClass('active');
      });
      $('body').on('click', '.overlay , .close-btn', function () {
        $(".ask-qus-popup").removeClass("active");
        $("body").removeClass("no_scroll");
        $('.overlay').removeClass('active');
      });
       /*********  size Popup  ********/
     $(".size-btn").click(function () {
      $(".size-popup").toggleClass("active");
      $("body").toggleClass("no_scroll");
    });
    $(".close-btn").click(function () {
        $(".size-popup").removeClass("active");
        $("body").removeClass("no_scroll");
    });
  //** product review js **//
  $('.product-review').click(function () {
    $('.product-review-form').toggleClass("showform");
  });
 
/********* Mobile Filter Popup ********/
      $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no_scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    });
 /********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").addClass("product-list-view ");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.product-list-view > .grid__item').each(function() {
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-price-wrapper').insertBefore(prod_form);  

        var prod_pri = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-variation-wrapper').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        
          var prod_label = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_label);
        
        var prod_btn2 = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.time-counter').insertAfter(prod_btn2); 

         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
         var timer_btn = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').prependTo(timer_btn);

         var timer_btn = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('p').insertAfter(timer_btn);

        var prod_title = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_title);

        var prod_rew = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-price-wrapper').appendTo(prod_rew);

        var prod_rew = jQuery(this).find('.product-price-wrapper');
        jQuery(this).find('.product-form').appendTo(prod_rew);

        var prod_btn = jQuery(this).find('.product-price-wrapper');
        jQuery(this).find('.product-variation-wrapper').insertBefore(prod_btn);  
        
      });
    });
    // load-more button scroll
if ($('.load-more_wrap').hasClass('load-more-btn')){
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val());
  var data_winurl = window.location.href.split('/collections');
  var final_data_url = data_winurl[1];
  var finalURL = "/collections" + final_data_url;
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      if (finalURL.includes('filter.')) {
        $('[data-next-link]').val(finalURL + "&page=" + next_coll);
       }else{
         $('[data-next-link]').val(finalURL + "?page=" + next_coll);
       }
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.product-grid-view, .product-list-view').append($(responseHTML).find('.product-grid-view, .product-list-view').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

      // start list
 // common list
      jQuery('.product-list-view > .grid__item').each(function() {
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.price').insertBefore(prod_form);  

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.variant-main').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    
 //   $(".menu-lnk.has-item").hover(function () {
 //    $('body').toggleClass("no-scroll");
 // });
  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-list-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });
}
// load-more button scroll end

// infinit scroll
if ($('.load-more_wrap').hasClass('infinite-scroll')){
var infinitelastLoadedUrl = "";
  // Function to load more products
  function infiniteloadMoreProducts(nextUrl, totalPages) {
    if (nextUrl === infinitelastLoadedUrl) {
          return; // Exit function if nextUrl is repeated
      }
     infinitelastLoadedUrl = nextUrl;
      var currentPage = parseInt($('[data-this-page]').val());
      var data_winurl = window.location.href.split('/collections');
      var final_data_url = data_winurl[1];
      var finalURL = "/collections" + final_data_url;
  
      // Disable load more button and show loader
      $('[loader]').removeClass('hide');
  
      var current_page_new = currentPage + 1;
      var next_coll = currentPage + 2;
  
      $.ajax({
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(responseHTML) {
             if (finalURL.includes('filter.')) {
              $('[data-next-link]').val(finalURL + "&page=" + next_coll);
             }else{
               $('[data-next-link]').val(finalURL + "?page=" + next_coll);
             }
            $('[data-this-page]').val(current_page_new);
  
              // Append loaded products to the container
              $('.product-grid-view, .product-list-view').append($(responseHTML).find('.product-grid-view, .product-list-view').html());
  
              // Call any necessary initialization functions
              countDownIni('.flip-countdown,.js-flip-countdown');
             // start list
 // common list

       jQuery('.product-list-view > .grid__item').each(function() {
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.price').insertBefore(prod_form);  

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.variant-main').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
          },
          complete: function() {
              if (current_page_new < totalPages) {
                  // Re-enable load more button and hide loader
                  $('[loader]').addClass('hide');
              } else {
                  // Hide load more button if there are no more pages
                  $('[loader]').removeClass('hide');
              }
          }
      });
  }
  
  // Scroll event listener for infinite scroll
  $.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }; 
  $(window).on('scroll load', function() {
  if ($('.load-more_wrap').isInViewport()) {
          var currentPage = parseInt($('[data-this-page]').val());
          var nextUrl = $('[data-next-link]').val();
          var totalPages = parseInt($('[data-all-pages]').val());
          if (currentPage >= totalPages) {
//             // Hide loader and exit function
            $('[loader]').addClass('hide');
        }else{
          infiniteloadMoreProducts(nextUrl, totalPages);
          $('[loader]').removeClass('hide');
        }
  }
  });
  
}
//end infinite
  function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-left-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-left-column').prependTo('.product-list-row');
      if($('body').hasClass('mobile-open') ){
        $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
        $('.overlay').removeClass('active');
     }
    
  }
     if(jQuery(window).width() < 992) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('div');
      newDiv.className = 'mobile-lag flex aling-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.languages , .currency').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
    $('.languages, .currency').prependTo('.menu-item-right');
    $('.mobile-lag').remove();
  }
}
    responsiveMenu();
  jQuery(window).resize(function() {
    responsiveMenu();
  });
/**************************/
        /** counter js **/
  /**************************/

  $('.counting').each(function () {
    var $this = $(this),
      countTo = $this.attr('data-count');

    $({ countNum: $this.text() }).animate({
      countNum: countTo
    },

      {
        duration: 3000,
        easing: 'linear',
        step: function () {
          $this.text(Math.floor(this.countNum));
        },
        complete: function () {
          $this.text(this.countNum);
        }

      });
  });

  
});
function countDownIni(countdown) {
 $(countdown).each(function () {
   var countdown = $(this);
   var promoperiod;
   if (countdown.attr('data-promoperiod')) {
     promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
   } else if (countdown.attr('data-countdown')) {
     promoperiod = countdown.attr('data-countdown');
   }
   if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
     $(this).addClass('countdown-block');
     countdown.countdown(promoperiod, function (event) {
       // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
       countdown.html(event.strftime("<div class='counter'><span class='count count-days'>%D</span></div>" + "<div class='counter'><span class='count count-hours'>%H</span></div>" + "<div class='counter'><span class='count count-minites'>%M</span></div>" + "<div class='counter'><span class='count count-seconds'>%S</span></div>"));
     });
   }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
 });
}
